import { useQuestGlitch } from '../QuestGlitchContext';
import { POINCON_QUEST_HOTSPOT } from '../questHotspots';
import { useQuestEnabled } from '../weddingCountdown';

export function QuestPoinconHotspot() {
  const questEnabled = useQuestEnabled();
  const { startQuestTransition } = useQuestGlitch();

  if (!questEnabled) {
    return null;
  }

  return (
    <button
      type="button"
      className="section__figure__hotspot"
      style={{
        top: `${POINCON_QUEST_HOTSPOT.top}%`,
        left: `${POINCON_QUEST_HOTSPOT.left}%`,
        width: `${POINCON_QUEST_HOTSPOT.width}%`,
        height: `${POINCON_QUEST_HOTSPOT.height}%`,
      }}
      onClick={() => startQuestTransition()}
      aria-label="Découvrir un indice"
    />
  );
}
